import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useTranslation } from 'react-i18next';

export interface IDeviceTypeDefaultLanguageEditorProps {
    value: string;
    supportsLocales: string[];
    onUpdate: (field: 'defaultLocale', value: string) => void;
}

export default function DeviceTypeDefaultLanguageEditor({
    value,
    supportsLocales,
    onUpdate,
}: IDeviceTypeDefaultLanguageEditorProps) {
    const { t } = useTranslation();

    return (
        <FormControl fullWidth>
            <InputLabel id={'defaultLocale'}>{t('common:organization.projects.deviceType.locale.title')}</InputLabel>
            <Select
                labelId={'defaultLocale'}
                value={value}
                label={t('common:organization.projects.deviceType.locale.title')}
                onChange={(e) => onUpdate('defaultLocale', e.target.value)}>
                {supportsLocales.map((locale, index) => (
                    <MenuItem key={locale + index} value={locale}>
                        {locale}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
